var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-transfer',{attrs:{"props":{ key: _vm.akey, label: _vm.label },"data":_vm.data,"left-default-checked":_vm.left_default_checked,"right-default-checked":_vm.right_default_checked,"titles":_vm.titles,"button-texts":_vm.buttonText},on:{"change":_vm.change},model:{value:(_vm.fvalue),callback:function ($$v) {_vm.fvalue=$$v},expression:"fvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }